import { render, staticRenderFns } from "./BilagForm.vue?vue&type=template&id=58fad71a&scoped=true&"
import script from "./BilagForm.vue?vue&type=script&lang=js&"
export * from "./BilagForm.vue?vue&type=script&lang=js&"
import style0 from "./BilagForm.vue?vue&type=style&index=0&id=58fad71a&lang=scss&scoped=true&"
import style1 from "./BilagForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fad71a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDialog,VIcon,VTextField,VTooltip})
